import * as types from './types'

export default {
  [types.IS_LOADING] (state, value) {
    state.isLoading = value
  },

  [types.HAS_UNREAD_MESSAGE] (state, value) {
    state.hasUnreadMessage = value
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/ui/mutations.js
// module id = null
// module chunks = 